// ImageSubmit.jsx
import React, { useState, useEffect } from "react";
import styles from "./ImageSubmit.module.scss";
import {hasValue} from "../../helpers/helperFunctions";
import Button from "../Button/Button";
import {useWallet} from "@solana/wallet-adapter-react";
import {PROD_API_URL} from "../../constants/constants";

const ImageSubmit = (props) => {
  const {
    text,
    useBase64 = true,
    preview,
    base64Value,
    setBase64,
    setFileInfo,
    resetButton,
  } = props;

  const wallet = useWallet();

  const [imagePreview, setImagePreview] = useState(hasValue(preview) ? preview : base64Value);

  useEffect(() => {
    if (!imagePreview && hasValue(base64Value)) {
      setImagePreview(base64Value);
    }
  }, [base64Value]);


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // preview
    const reader = new FileReader();
    reader.onloadend = () => setImagePreview(reader.result);
    reader.readAsDataURL(file);
    setFileInfo(file);
    // propagate base64 if needed
    if (useBase64) {
      const base64 = await new Promise((res, rej) => {
        const fr = new FileReader();
        fr.onload = () => res(fr.result);
        fr.onerror = rej;
        fr.readAsDataURL(file);
      });
      setBase64(base64);
    }
  };

  return (
      <div className={styles.imageSubmitContainerOuter}>
        <label className={styles.imageSubmitContainer}>

          <div className={styles.logoContainer}>
            {imagePreview && <img src={imagePreview} className={styles.logoImage} alt="Preview"/>}
          </div>

          {!resetButton ? <div style={{width: 56 + "px"}}/> : resetButton}
          <input
              type="file"
              accept=".jpeg,.jpg,.png"
              className={styles.hiddenInput}
              onChange={handleFileChange}
          />
        </label>
      </div>
  );
}

export default ImageSubmit;
